import React, {Component} from 'react';

import {find} from 'lodash';

class CheckboxGroup extends Component {
    state = {
        errorsContainerId: false,
    };

    isChecked = (current_value) => {
        const values = this.props.values || [];

        return find(values, (item) => item == current_value);
    };

    onChange = ({ target }) => {
        const { name, updateMethod, values = [] } = this.props;
        const new_value = [...values];

        if (target.checked) {
            new_value.push(target.value);
        } else {
            new_value.splice(values.indexOf(target.value), 1);
        }

        const new_target = {
            name,
            value: new_value,
        };

        updateMethod({ target: new_target });
    };

    renderCheckbox = (option, index) => {
        const {
            name,
            optionId,
            optionLabel,
            optionValue,
            required,
            errorContainer,
            errorMessage,
            containerClassName,
            addErrorsContainer,
            lessSpace,
            disabled
        } = this.props;
        const id = this.props.id || name;

        const label = option[optionLabel];
        const value = option[optionValue];
        const checkboxOptionId = (option[optionId] || id).toLowerCase().replace(/\s/g, '-');

        const errorsContainer = addErrorsContainer === true
            ? `#${name}-errors-container`
            : errorContainer;

        return (
            <div className={`st-checkbox ${containerClassName} ${lessSpace ? 'less-space' : ''}`}
                 key={`${id}-${value}`}>
                <input
                    key={`checkbox-${index}`}
                    id={`${id}-${value}`}
                    type="checkbox"
                    className="filter-checkbox"
                    name={name}
                    value={value}
                    required={required}
                    checked={this.isChecked(value)}
                    onChange={this.onChange}
                    data-parsley-errors-container={errorsContainer}
                    data-parsley-required-message={errorMessage}
                    disabled={disabled}
                />
                <label id={`${checkboxOptionId}-${value}`} htmlFor={`${id}-${value}`}
                       className={`checkbox-label ${disabled?'disabled':''}`} key={`${id}-${value}`}>
                    <div>
                        {label}
                    </div>
                </label>
            </div>
        );
    };

    render() {
        const {
            id,
            name,
            label,
            options,
            className,
            withGroupWrapper,
            addErrorsContainer,
        } = this.props;

        if (!withGroupWrapper) {
            return (
              <div id={id || className} className={className}>
                  {options.map((checkbox, index) => this.renderCheckbox(checkbox, index))}
              </div>
            );
        }

        return (
          <div id={id} className={className}>
            <div className="form-group">
              {label ? <label className="form-label checkbox-group-label">{label}</label> : ''}
              {addErrorsContainer ? (
                <span id={`${name}-errors-container`} />
                    ) : null}
              {options.map((checkbox, index) => this.renderCheckbox(checkbox, index))}
            </div>
          </div>
        );
    }
}

CheckboxGroup.defaultProps = {
    label: undefined,
    withGroupWrapper: true,
    name: 'undefined',
    className: '',
    containerClassName: '',
    id: undefined,
    required: false,
    addErrorsContainer: false,
    errorContainer: false,
    lessSpace: false,
    errorMessage: 'This field is required.',
    values: [],
    options: [],
    optionLabel: 'label',
    optionValue: 'id',
    optionId: 'id',
    updateMethod: () => {
        alert('PaymentTypeCheckbox update method is required');
    },
};

export default CheckboxGroup;
